import axios from "axios";
import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useParams } from "react-router-dom";

function QrTemplate() {
  const { username, id } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchUserData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/qrc/social-net/scan/${id}`
      );
      setData(response.data.data.data);
    } catch (error) {
      console.error("Failed Fetching Details", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUserData();
  }, [id]);

  // 🔹 File Template UI
  const renderFileTemplate = () => (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      <button
        onClick={() => window.open(data.fileLink, "_blank")}
        style={{
          padding: "10px 20px",
          fontSize: "16px",
          margin: "10px",
          cursor: "pointer",
        }}
      >
        📥 Download File
      </button>
      <button
        onClick={() => (window.location.href = "https://demo.dirido.com/")}
        style={{
          padding: "10px 20px",
          fontSize: "16px",
          backgroundColor: "red",
          color: "white",
          border: "none",
          cursor: "pointer",
        }}
      >
        🏠 Go Home
      </button>
    </div>
  );

  // 🔹 V-Card Template UI
  const renderVCardTemplate = () => {
    const d = data;
    const address = d.address
      ? `${d.address.street}, ${d.address.city}, ${d.address.state}, ${d.address.country} - ${d.address.zipCode}`
      : "";

    const cardStyle = {
      border: "1px solid #d4d4d4",
      margin: "7px",
      borderRadius: "10px",
      background: "rgb(231,238,243)",
      display: "flex",
      flexDirection: "column",
    };

    return (
      <Container className="p-0">
        <Row className="no-gutters height-self-center">
          <Col sm="12" className="text-center align-self-center">
            <div style={cardStyle}>
              <div
                style={{
                  borderRadius: "10px",
                  paddingBlock: "10px",
                  background: "rgb(66,128,231)",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <img
                  src={d?.profileImageLink || "/profile.png"}
                  alt="Profile"
                  style={{
                    display: "flex",
                    width: "90px",
                    marginInline: "auto",
                    borderRadius: "100px",
                    border: "3px solid #fff",
                    marginTop: "10px",
                  }}
                />
                <label
                  style={{
                    display: "flex",
                    marginInline: "auto",
                    fontSize: "14px",
                    color: "#fff",
                  }}
                >
                  {d.name}
                </label>
                <label
                  style={{
                    display: "flex",
                    marginInline: "auto",
                    fontSize: "12px",
                    color: "#fff",
                  }}
                >
                  {d.designation}
                </label>
                <label
                  style={{
                    display: "flex",
                    marginInline: "auto",
                    fontSize: "12px",
                    color: "#fff",
                  }}
                >
                  {d.companyName}
                </label>
              </div>

              {[
                { label: "Description", value: d.personalDescription },
                { label: "Email", value: d.contactInfo?.email },
                { label: "Phone", value: d.contactInfo?.phone },
                { label: "Company", value: d.companyName },
                { label: "Position", value: d.designation },
                { label: "Address", value: address },
              ].map((item, idx) => (
                <div
                  key={idx}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    background: "white",
                    paddingInline: "10px",
                    borderRadius: "5px",
                    marginBottom: "8px",
                    marginInline: "8px",
                    textAlign: "left",
                  }}
                >
                  <div style={{ display: "flex", fontWeight: "600" }}>
                    {item.label} :
                  </div>
                  <div style={{ display: "flex" }}>{item.value}</div>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    );
  };

  // 🔹 Conditional Rendering
  if (loading) return <p style={{ textAlign: "center" }}>Loading...</p>;
  if (!data) return <p style={{ textAlign: "center" }}>No Data Found</p>;

  switch (data.__t) {
    case "file":
      return renderFileTemplate();
    case "v-card":
      return renderVCardTemplate();
    default:
      return <p style={{ textAlign: "center" }}>Unsupported type</p>;
  }
}

export default QrTemplate;
